// extracted by mini-css-extract-plugin
export default {"number":"score-number_number__iFsZU","number1":"score-number_number1__bDMJs","number2":"score-number_number2__bUDUk","number3":"score-number_number3__WTAQo"};